export const ENV = {
    PRODUCTION: 'production',
    DEVELOPMENT: 'development',
    QA: 'qa',
}